import React from 'react';

import './index.scss';

const GlobalFooter = props => {
  const {
    className,
  } = props;

  return (
    <footer className={className}>
      <ul className="guide">
        <li>
          <strong>BetConstruct</strong>{` `}{new Date().getFullYear()}
        </li>
        <li>
          <a target="_blank" rel="noopener noreferrer" href="https://www.betconstruct.com/terms-and-conditions">
            Terms & Conditions
          </a>
          <a target="_blank" rel="noopener noreferrer" href="https://www.betconstruct.com/privacy-policy">
            Privacy Policy
          </a>
          <a target="_blank" rel="noopener noreferrer" href="https://www.betconstruct.com/cookie-policy">
            Cookie Policy
          </a>
        </li>
      </ul>
    </footer>
  )
};

export default GlobalFooter;
